function Ctrl($scope) {
  $scope.$watch('ratingAverage', function() {
    generateStars();
  });

  function generateStars() {
    if (!$scope.ratingAverage) return;

    $scope.stars = [];

    $scope.ratingAverage = parseFloat($scope.ratingAverage);

    let numPart = $scope.ratingAverage % 1;
    const numWhole = $scope.ratingAverage - numPart;
    numPart = numPart.toFixed(2);

    for (let i = 1; i <= numWhole; i++) { //eslint-disable-line
      $scope.stars.push({
        icon: 'fa fa-star'
      });
    }

    if (numPart && numPart >= 0.5) {
      $scope.stars.push({
        icon: 'fa fa-star-half-full'
      });
    }

    const emptyStars = 5 - $scope.stars.length;

    for (let i = 1; i <= emptyStars; i++) { //eslint-disable-line
      $scope.stars.push({
        icon: 'fa fa-star-o'
      });
    }
  }
}

Ctrl.$inject = [
  '$scope'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/venueRating/controller.js